module.exports = __webpack_public_path__ + "static/media/flag.915c214d.svg";